import type { FaireProductEntity } from "../../entity_types/product";

export const p_92z8gq8tq4: FaireProductEntity = {
  token: "p_92z8gq8tq4",
  type: "product",
  name: "Phillipe Dog - Organic Fine Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1bf7a4193c440031db78001ee3c65eaa67bd25c5f1e9db7f402a668bcc5c2383.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3aaaa1f2d6287d41138b7b5829281d2aa0b51a8432317e224e13e18ae9ee31ce.jpeg",
    "https://cdn.faire.com/fastly/1e9f04549fc7460db2b20e73e3f5713348abd6f040df4c24635643629e52918b.jpeg",
    "https://cdn.faire.com/fastly/90898114ad2e5198fb58a8d9f169063dffd1eb4a846f806256fc48e03b4a41cb.jpeg",
    "https://cdn.faire.com/fastly/0ef97fdd7185d76804a826b6a461a4509678a23b70fb347ad90270d443ddb07c.jpeg",
    "https://cdn.faire.com/fastly/1f0d94c0be4679c3b9961b84a79a5f28ad6d22ce82c60e3abb4d96b21ec8fe26.jpeg",
    "https://cdn.faire.com/fastly/2953efe18ea9bdcb5b4bd0da4da0cbe2d9c09427d8dff27829f59abacd7143fc.jpeg",
    "https://cdn.faire.com/fastly/47cf00e15254ea06f52b5e08bef620260f57e7442af7f416a003e16a4bcc6dac.jpeg",
    "https://cdn.faire.com/fastly/db1eee4226bde01d488ca1dbd15a5ec4c15609131a7138a7587886f1496ed31c.jpeg",
    "https://cdn.faire.com/fastly/48ca7bd3916ca672aa1da82e55dacd45d6922916f89bd6f77fcc4eafe4d93ac1.jpeg",
    "https://cdn.faire.com/fastly/cb3414a474379ebd3d2e875929348e947d6504c3aca278d02606013982223607.jpeg",
    "https://cdn.faire.com/fastly/f732a45df85c10ec7bbcd7359929944758f12d509c7b321b2e5266d60c1ac171.jpeg",
    "https://cdn.faire.com/fastly/c9f24f83b187788745c22da383c9e3003c06fcaff47696a98d99dce07bcb1d0c.jpeg",
    "https://cdn.faire.com/fastly/7767c170313caa9109f3e670c50d4c3201a327bd7f42182ce8db3a4128f10f36.jpeg",
  ],
  priceDollars: 20,
  description:
    'Phillipe, the Dog Inspector is curious and loves to sniff around. Phillipe is always ready for an adventure.\n\n• 100% organic cotton outer shell, poly fill inside.\n• Size: 12" x 6"\n• Weight: 4 oz\n• For babies, kids & adults, 8 months and up.\n\n𝐕𝐢𝐯𝐞𝐫𝐚𝐧𝐨 𝐎𝐫𝐠𝐚𝐧𝐢𝐜 𝐓𝐨𝐲𝐬:\n• Quirky & cuddly collection of organic cotton knit toys for your precious little ones.\n• Fresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\n• Lovingly made by hand using certified organic cotton, safe for hugging & snuggling.\n• Great for buddy adventures, good company and bedtime snuggles.\n• Heirloom quality, non-toxic and eco-friendly materials.\n• Slight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\n• Ethically handcrafted by artisans at a GOTS certified facility in India.\n• Easy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\n• Made in India.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:30.616Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
